var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 0C24.0604 0 31 6.93959 31 15.5C31 24.0604 24.0604 31 15.5 31C6.93959 31 0 24.0604 0 15.5C0 6.93959 6.93959 0 15.5 0ZM15.5 2.58333C8.36632 2.58333 2.58333 8.36632 2.58333 15.5C2.58333 22.6337 8.36632 28.4167 15.5 28.4167C22.6337 28.4167 28.4167 22.6337 28.4167 15.5C28.4167 8.36632 22.6337 2.58333 15.5 2.58333ZM15.5 6.45833C16.2134 6.45833 16.7917 7.03663 16.7917 7.75V16.2566L21.5738 21.0387C22.0782 21.5432 22.0782 22.361 21.5738 22.8654C21.0693 23.3698 20.2515 23.3698 19.7471 22.8654L14.5867 17.705C14.3529 17.4713 14.2083 17.1483 14.2083 16.7917V7.75C14.2083 7.03663 14.7866 6.45833 15.5 6.45833Z",
    fill: "#060606"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/clock--icon.d0a660450ac1d23c643660365d23e449.svg";
export { ForwardRef as ReactComponent };